import { Navigate, useSearchParams } from "react-router";

const RedirectFromOldOrgPages = () => {
  const [searchParams] = useSearchParams();

  const codeParam = searchParams.get("email-or-code");

  return <Navigate to={`/employee?email-or-code=${codeParam}`} />;
};

export default RedirectFromOldOrgPages;
